/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Event_Nda_Opened10Inputs */

const en_coinvestments_audit_event_nda_opened10 = /** @type {(inputs: Coinvestments_Audit_Event_Nda_Opened10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA Opened`)
};

/**
* | output |
* | --- |
* | "NDA Opened" |
*
* @param {Coinvestments_Audit_Event_Nda_Opened10Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_event_nda_opened10 = /** @type {((inputs?: Coinvestments_Audit_Event_Nda_Opened10Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Event_Nda_Opened10Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_event_nda_opened10(inputs)
});
export { coinvestments_audit_event_nda_opened10 as "coInvestments_audit_event_NDA_OPENED" }